import { render } from "./qualification.vue?vue&type=template&id=798183cf&scoped=true"
import script from "./qualification.vue?vue&type=script&lang=js"
export * from "./qualification.vue?vue&type=script&lang=js"

import "./qualification.vue?vue&type=style&index=0&id=798183cf&lang=less&scoped=true"

import exportComponent from "E:\\suooter\\36live\\live\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-798183cf"]])

export default __exports__